import { IconButton } from '@components/icon-button';
import { IconCloseRegular } from '@components/icons/close-regular';
import { Stack } from '@components/stack';
import { Text } from '@components/text';

import { ModalProps } from 'features/modals';
import { useStore } from 'models/Provider';

import { FormResponse } from './api/requests';
import { NewForm } from './OnboardingPage';

type Props = ModalProps<{
  data: FormResponse;
  oneTemplate: boolean;
  applicationId: string;
}>;

export const OnboardingFormResendModal = (props: Props) => {
  const { closeModal, data, oneTemplate, applicationId } = props;
  const { t } = useStore();

  return (
    <Stack space={6}>
      <Stack orientation="horizontal" space={2} justify="space-between">
        <Text
          font="heading1"
          color="purple100"
          text={t('integrations.onboardingform.resend.modal.header')}
        />
        <IconButton variant="ghost-purple" onClick={closeModal} icon={<IconCloseRegular />} />
      </Stack>
      <NewForm
        data={data}
        oneTemplate={oneTemplate}
        applicationId={applicationId}
        resend
        closeModal={closeModal}
      />
    </Stack>
  );
};
